import { isNebulyPagePath } from '@/domains/pages/constants';
import type { ReportSubproduct } from '@/domains/reports/utils/report-subproduct.utils';

/** Rail highlight follows URL navigation intent, not content fallback from project config. */
export function getSubproductRailHighlightSubproduct(routeSubproduct: ReportSubproduct): ReportSubproduct {
  return routeSubproduct;
}

export function isSubproductPageRailContext(pathname: string): boolean {
  return (
    pathname === '/reports' || pathname === '/explore' || pathname === '/all-reports' || isNebulyPagePath(pathname)
  );
}

export function isSubproductRailItemActive(
  pathname: string,
  subproductQuery: string | null | undefined,
  subproduct: ReportSubproduct,
): boolean {
  return isSubproductPageRailContext(pathname) && subproductQuery === subproduct;
}
